import assocIndexOf from "./component-library475.mjs";
function listCacheGet(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}
export {
  listCacheGet as default
};
